import {
    LessonProblem,
    SkillsLessonStructureCardStack,
    SkillsLessonStructureCardStacks,
    StudentProblemResult,
} from '@yandex-int/k-common';
import { findLast } from '@yandex-int/k-common/utils/array';

import {
    isTheory,
    isStudentProblemCorrect,
    isStudentProblemIncorrect,
    isStudentProblemSeen,
    isStudentProblemWithAttempts,
} from 'store/problems/utils';

export function filterTheoryStacks(stacks: SkillsLessonStructureCardStacks, problemMap: Record<number, LessonProblem>) {
    return stacks.filter((stack) =>
        stack.some((problemId) => {
            return isTheory(problemMap[problemId]?.problem);
        })
    );
}

export function filterSuccessStacks(
    stacks: SkillsLessonStructureCardStacks,
    problemMap: Record<number, LessonProblem>,
    result: Record<number, StudentProblemResult>
) {
    return stacks.filter((stack) =>
        stack.some((problemId) => {
            const problemLink = problemMap[problemId];
            return isStudentProblemCorrect(problemLink, result);
        })
    );
}

export function filterSeenStacks(
    stacks: SkillsLessonStructureCardStacks,
    problemMap: Record<number, LessonProblem>,
    result: Record<number, StudentProblemResult>
) {
    return stacks.filter((stack) =>
        stack.some((problemId) => {
            const problemLink = problemMap[problemId];
            return isStudentProblemSeen(problemLink, result);
        })
    );
}

export function filterFailStacks(
    stacks: SkillsLessonStructureCardStacks,
    problemMap: Record<number, LessonProblem>,
    result: Record<number, StudentProblemResult>
) {
    return stacks.filter((stack) => {
        const hasCorrect = stack.some((problemId) => {
            const problemLink = problemMap[problemId];
            return isStudentProblemCorrect(problemLink, result);
        });
        if (hasCorrect) {
            return false;
        }
        const lastProblemWithAttempts = findLast(stack, (problemId) =>
            isStudentProblemWithAttempts(problemMap[problemId], result)
        );
        if (!lastProblemWithAttempts) {
            return false;
        }
        const problemLink = problemMap[lastProblemWithAttempts];
        return isStudentProblemIncorrect(problemLink, result);
    });
}

export function getLastAnsweredOrFirstProblemLink(
    stack: SkillsLessonStructureCardStack,
    problemMap: Record<number, LessonProblem>,
    result: Record<number, StudentProblemResult>
) {
    const lastProblemWithAttempts = findLast(stack, (problemId) =>
        isStudentProblemWithAttempts(problemMap[problemId], result)
    );

    return problemMap[lastProblemWithAttempts || stack[0]];
}

export function getPerformanceProblemLink(
    stack: SkillsLessonStructureCardStack,
    problemMap: Record<number, LessonProblem>,
    result: Record<number, StudentProblemResult>
) {
    const problemLink = getLastAnsweredOrFirstProblemLink(stack, problemMap, result);
    if (problemLink) {
        if (isTheory(problemLink.problem)) {
            return null;
        }
    }

    return problemLink;
}
